import { Timestamp } from "firebase/firestore";

export const ADMIN_EVENT_DOC = "admin_event_doc";
export const LOGGED_IN_ADMIN_EVENTS = "logged_in_admin_events";
export const INTERNAL_ADMIN_IS_LOGGEDIN = "INTERNAL_ADMIN_IS_LOGGEDIN";
export const INTERNAL_ADMIN_LOGIN_EXPIRY = "INTERNAL_ADMIN_LOGIN_EXPIRY";

export function nowTime() {
  return new Date().getTime();
}

export const formatMoney = (value: number) =>
  new Intl.NumberFormat("en-US", {}).format(value);

export const formatMoneyInInputBox = (value: string) => {
  const cleanedValue = Number(value.replace(/[^0-9]/g, ""));
  return Number(cleanedValue);
};

export const NAIRA_SYMBOL = "₦";

export const formatFirestoreTimestamp = (timestamp: Timestamp) => {
  const date = timestamp.toDate(); // convert Firestore Timestamp to JS Date
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const statusColor = (st: string) => {
  const status = st.toLowerCase();
  if (["checked-in", "completed", "regular"].includes(status)) return "success";
  if (["going", "general-admission"].includes(status)) return "processing";
  if (["did not attend"].includes(status)) return "error";
  if (["vip"].includes(status)) return "secondary";
  return "secondary";
};

export const ticketTypeHolder = (ticketTitle: string) => {
  const ticketType = ticketTitle?.toLowerCase() || "";
  if (ticketType === "general admission" || !ticketType)
    return { status: "General Admission", colorType: "general-admission" };
  if (ticketType === "vip") return { status: "VIP", colorType: "vip" };
  if (ticketType === "regular")
    return { status: "Regular", colorType: "regular" };
  return { status: ticketTitle, colorType: "general-admission" };
};

export const isEmailValid = (email: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// export function getPaystackFee(amount: number) {
//   let fee = amount * 0.015;
//   if (amount >= 2500) {
//     fee += 100;
//   }
//   return fee > 2000 ? 2000 : fee;
// }

export function createGradient(colors: string[], direction = "to right") {
  if (!Array.isArray(colors) || colors.length === 0) {
    throw new Error("Please provide an array of at least one color.");
  }

  // Join colors into a CSS gradient string
  const gradient = `linear-gradient(${direction}, ${colors.join(", ")})`;
  return gradient;
}

export const getHourInMilliseconds = (hours: number) => {
  return hours * 60 * 60 * 1000;
};

export const createCamelCaseId = (...strings: string[]) => {
  const cleaned = strings
    .join(" ")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "") // remove special characters
    .split(/\s+/) // split by spaces
    .map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");

  const random = Math.random().toString(36).substr(2, 6); // random 6 chars

  return `${cleaned}${random}`;
};
